export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9020.85c2d855.jpg";